import React from 'react';
import { inputs } from '@ecosystem/newron-design-system';
import { ContextSettingSelectorProps } from '../types';
import { Entity } from '../../types';
import { ContextSelectorMenu } from './menu';

function RadioGroupSelector({ definition, values, onChange, onClose }: ContextSettingSelectorProps) {
  const {
    name,
    selection: { options },
  } = definition;
  if (!options) {
    return <span className="py-1 text-ui-red">!!No configured options!!</span>;
  }

  const radioOptions: Entity[] = options.filter(opt => typeof opt !== 'string').map(opt => opt as Entity);

  const handleChange = (value: string) => {
    const option = radioOptions.find(opt => opt.value === value);
    if (option) {
      onChange({
        [name]: [option],
      });
    }
    onClose();
  };

  const { RadioButtons } = inputs;

  return (
    <ContextSelectorMenu>
      <RadioButtons orientation={'horizontal'} onChange={handleChange} value={values[0].value} options={radioOptions} />
    </ContextSelectorMenu>
  );
}

export { RadioGroupSelector };
